<template>
    <div class="campaign-option">
        <div class="campaign-option--title">
            Ad Set Name
            <info-tooltip text="Give your ad set a name that describes the audience, scheduling, or products inside it."></info-tooltip>
        </div>
        <input type="text" class="campaign-adset-name__input text-input" id="ad_set_name" v-model="name"
               v-on:input="setValue($event.target.value)"
               placeholder="Enter a name for this Ad Set">
        <slot name="validation"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
                default: 'value'
            }
        },
        data() {
            return {
                name: this.value
            }
        },
        watch: {
            value(val) {
                this.name = val;
            }
        },
        methods: {
            setValue(value) {
                this.name = value;
                this.$emit('input', value);
            }
        }
    }
</script>
